const featureConfig = {
  restoreDataEnabled: true,
  securityOverlayEnabled: true,
  onboardingSettings: true,
};

export default featureConfig;
